import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useCategoriesStore = defineStore('categories', () => {

    const showAll = ref(false);
    const showCategoryFilters = ref(false);
    const chosenTopLevelCategory = ref();
    const topLevelCategories = ref([]);
    const categories = ref([]);

    function setShowAll(value) {

        showAll.value = value;

    }

    function setShowAllToFalse() {

        showAll.value = false;

    }

    function uncheckAllCategories() {

        categories.value.forEach((category) => {

            // eslint-disable-next-line no-param-reassign
            category.checked = false;

        });

    }

    function setShowCategoryFilters(value) {

        showCategoryFilters.value = value;

    }

    function setChosenTopLevelCategory(value) {

        chosenTopLevelCategory.value = value;

    }

    function updateCategories(data) {

        categories.value = data;

    }

    function updateTopLevelCategories(data) {

        topLevelCategories.value = data;

    }

    return {
        showAll,
        showCategoryFilters,
        chosenTopLevelCategory,
        topLevelCategories,
        categories,
        setShowAll,
        setShowAllToFalse,
        uncheckAllCategories,
        setShowCategoryFilters,
        setChosenTopLevelCategory,
        updateCategories,
        updateTopLevelCategories,
    };

});
